<template>
  <b-card
    title="مدیریت دوره های ورزشی"
  >
    <b-row>
      <b-col
          class="table-size"
      >
        <div class="custom-search">
          <b-row>
            <div class="filter-row">
              <b-button
                variant="primary"
                class="mb-1 mr-auto ml-1"
                :to="{ name: 'addactivitypackagecourse'}"
              >
                جدید
              </b-button>
              <b-col md="2">
                <b-form-group>
                  <b-form-group
                    label="عنوان"
                    label-for="Title"
                    class="m-0"
                  >
                    <b-form-input
                      v-model="filterOptions.Title"
                      @keyup.enter="update(1)"
                    />
                  </b-form-group>
                </b-form-group>
              </b-col>
              <b-col md="2">
                <b-form-group
                    label="برنامه ورزشی"
                    label-for="ActivityPackageId"
                >
                  <z-activity-package
                      v-model="filterOptions.ActivityPackageId"
                      :multiple="false"
                      :clearable="true"
                  />
                </b-form-group>
              </b-col>
              <b-button
                v-ripple.400="'rgba(186, 191, 199, 0.15)'"
                class="mb-1 mr-1"
                variant="warning"
                @click="update(1)"
              >فیلتر
              </b-button>
            </div>
          </b-row>
        </div>

        <b-table
          bordered
          hover
          striped
          :items="items"
          :fields="fields"
          class="mt-1 mb-2 position-relative"
          responsive
          :busy="loading"
        >
          <template #cell(Id)="data">
            <b-link
              :to="{ name: 'updateactivitypackagecourse', params: { id: data.value }}"
              class="font-weight-bold"
            >
              #{{ data.value }}
            </b-link>
          </template>

          <template #cell(ActivityCategory)="data">
            <span
              v-for="(item, index) in data.value"
              :key="index"
            >
              <b-badge
                style="line-height: unset; margin: 2px;"
                variant="info"
              >
                {{ item.Title }}
              </b-badge>
            </span>
          </template>

          <template #cell(Level)="data">
            <b-badge
              :variant="enums('Level', 'value', data.value, 'badge')"
            >
              {{ enums('Level', 'value', data.value, 'text') }}
            </b-badge>
          </template>

          <template #cell(Price)="data">
            {{ data.value | price }}
          </template>

          <template #cell(Discount)="data">
            {{ data.value | price }}
          </template>

          <template #cell(ActivityPackage)="data">
            {{ data.value.Title }}
          </template>

          <template #cell(actions)="data">

            <div
              class="text-nowrap"
            >
              <b-link :to="{ name: 'updateactivitypackagecourse', params: { id: data.item.Id }}">
                <feather-icon
                  :id="`invoice-row-${data.item.Id}-send-icon`"
                  icon="EditIcon"
                  size="16"
                />
              </b-link>

              <feather-icon
                icon="TrashIcon"
                size="16"
                class="ml-1 cursor-pointer"
                @click="remove(data.item.Id)"
              />

              <feather-icon
                icon="FileTextIcon"
                size="16"
                class="ml-1 cursor-pointer"
                @click="summary(data.item.Id)"
              />
            </div>
          </template>

          <template #table-busy>
            <div
              class="text-center my-2"
            >
              <b-spinner
                variant="primary"
                class="align-middle"
              />
              <strong class="ml-1">در حال دریافت اطلاعات ...</strong>
            </div>
          </template>

        </b-table>

        <z-pagination
          :page="filterOptions.Page"
          :total-rows="totalRows"
          :loading="loading"
          @change="update"
        />

      </b-col>

    </b-row>

    <b-modal
        id="modal-summary"
        hide-footer
        modal-class="modal-seconday"
        centered
        title="خلاصه برنامه ورزشی"
    >
      <div style="text-align: left; direction: ltr; line-height: 2.5rem;">
        <div v-for="(item, index) in exercise" :key="index">
        <span class="badge badge-light-dark" style="font-weight: 600; font-size: 1rem; color: #5e50ee !important;">{{item.SetCount}}</span> * [
          <span v-for="(details, i) in item.ActivityPackageCourseExerciseDetails" :key="i">
            <span style="font-size: 1rem;" class="badge badge-light-dark">
               {{details.Activity.Title}}
              <span style="font-weight: 600; color: #5e50ee;">{{details.Amount}}{{details.Type === 0 ? ' s' : ' n'}}</span>
              <span style="font-weight: 600; font-size: 85%;"> {{ details.Side === null ? '' : (details.Side === 0 ? 'Left' : 'Right') }}</span>
            </span>

            <span v-if="(i + 1 ) != item.ActivityPackageCourseExerciseDetails.length"> + </span>
          </span>
          <span>&nbsp;&nbsp;&nbsp;&nbsp;</span>
          ]
          <span style="font-weight: 600; font-size: 1rem;" class="badge badge-light-warning">{{ item.SetRestTime }} s</span>
          <span style="font-weight: 600; font-size: 1rem; margin-left: 0.4rem;" class="badge badge-light-info">{{ item.RestTime }} s</span>
        </div>
      </div>
    </b-modal>

  </b-card>
</template>

<script>

import ZActivityPackage from "@/tools/activitypackage";

export default {
  name: 'ActivityPackageCourse',
  components: {
    ZActivityPackage,
  },
  data() {
    return {
      totalRows: 1000 * 1000,
      loading: false,
      filterOptions: {
        Title: null,
        Page: 1,
      },
      exercise: [],
      fields: [
        {
          key: 'Id',
          label: '#',
          thClass: 'col-width-50',
        },
        {
          key: 'Title',
          label: 'عنوان',
        },
        {
          key: 'ActivityPackage',
          label: 'برنامه ورزشی',
        },
        {
          key: 'Price',
          label: 'قیمت',
        },
        {
          key: 'Discount',
          label: 'تخفیف',
        },
        {
          key: 'Level',
          label: 'سطح',
        },
        {
          key: 'actions',
          label: '',
          thClass: 'col-width-50',
        },
      ],
      items: [],
    }
  },
  created() {
    if (this.$store.state.zirehState.listFilter[this.$options.name]) {
      this.filterOptions = this.$store.state.zirehState.listFilter[this.$options.name]
    }
    this.update()
  },
  methods: {
    sortChange(e) {
      if (e.sortBy) {
        this.filterOptions.SortBy = e.sortBy
        this.filterOptions.IsDesc = e.sortDesc
        this.update(1)
      }
    },
    update(pageNumber) {
      this.loading = true

      this.filterOptions.Page = pageNumber || this.filterOptions.Page

      this.$store.commit('zirehState/setListFilter', { key: this.$options.name, value: this.filterOptions })

      this.$http.post(
        this.$api.activitypackagecourse.getlist, this.filterOptions,
      )
        .then(res => {
          this.totalRows = res.totalRow
          this.items = res.data
        })
        .finally(() => {
          this.loading = false
        })
    },
    summary(id){
      this.$http.post(
          this.$api.activitypackagecourse.summary, {id},
      )
          .then(res => {
            this.exercise = res.data
            this.$bvModal.show('modal-summary')
          })
    },
    remove(id) {
      this.removeRow(this.$api.activitypackagecourse.remove, 'Id', id)
    },
  },
}
</script>
